<div class="container p-3">
    <div class="row mat-elevation-z2 rounded p-4">

        <h1 class="mb-0">Set up your assistant's knowledge</h1>
        <h4 class="fw-light mb-0">This section will allow you to add the data that your assistant will use to
            communicate with clients</h4>

        <mat-divider class="mt-4 mb-4"></mat-divider>

        <!-- KNOWLEDGE BASE CREATION SECTION -->
        <h1>Add knowledge base</h1>

        <div class="row">
            <div class="col-12 mb-4">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Knowledge base name</mat-label>
                    <mat-hint>Enter a knowledge base name to recognize it</mat-hint>
                    <input [readonly]="isKnowledgeLoading || isDeleteKnowledgeLoading" type="text" matInput [formControl]="knowledgeName" />
                    <mat-error *ngIf="knowledgeName.hasError('required')">this field is required</mat-error>
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Select a knowledge base type</mat-label>
                    <mat-select [formControl]="knowledgeBaseType">
                        <mat-option *ngFor="let item of knowledgeBaseTypes" [value]="item">{{item}}</mat-option>
                    </mat-select>
                    <mat-hint align="start">Select the type of data for your assistant's knowledge</mat-hint>
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field *ngIf="!isWebsiteUrlKnowledgeBase()" appearance="outline" class="w-100">
                    <mat-label>File matInput</mat-label>
                    <mat-hint>Enter a pdf file</mat-hint>
                    <button (click)="f_input.click()" type="button" mat-icon-button matPrefix>
                        <mat-icon>attach_file</mat-icon>
                    </button>
                    <button *ngIf="display.valid" (click)="display.reset()" type="button" mat-icon-button matSuffix>
                        <mat-icon>clear</mat-icon>
                    </button>
                    <input type="text" readonly matInput [formControl]="display" />
                    <input [readonly]="isKnowledgeLoading || isDeleteKnowledgeLoading" type="file" accept="application/pdf" multiple hidden #f_input
                        (change)="handleFileInputChange(f_input.files!)" />
                    <mat-error *ngIf="display.hasError('required')">this field is required</mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="isWebsiteUrlKnowledgeBase()" appearance="outline" class="w-100">
                    <mat-label>Website url</mat-label>
                    <input [readonly]="isKnowledgeLoading || isDeleteKnowledgeLoading" matInput placeholder="https://mywebsite.com" required
                        [formControl]="webScrapeUrl">
                    <mat-hint>Enter the website url of your business</mat-hint>
                    <mat-error *ngIf="webScrapeUrl.hasError('required')">this field is required</mat-error>
                    <mat-error *ngIf="webScrapeUrl.hasError('pattern')">Bad format of website</mat-error>
                </mat-form-field>
            </div>

            <div class="row mt-4">
                <div class="col-lg-12 text-center">
                    <button [disabled]="!(this.webScrapeUrl.valid && this.knowledgeName.valid) || isKnowledgeLoading || isDeleteKnowledgeLoading"
                        *ngIf="isWebsiteUrlKnowledgeBase()" (click)="onWebScrape()" type="button" mat-raised-button
                        class="w-25">
                        <span *ngIf="!isKnowledgeLoading">Scrape</span>
                        <mat-icon *ngIf="!isKnowledgeLoading">construction</mat-icon>

                        <mat-spinner *ngIf="isKnowledgeLoading" [diameter]="30" [strokeWidth]="3"
                            class="mx-auto mat-spinner"></mat-spinner>
                    </button>

                    <button [disabled]="!(this.display.valid && this.knowledgeName.valid) || isKnowledgeLoading || isDeleteKnowledgeLoading"
                        *ngIf="!isWebsiteUrlKnowledgeBase()" (click)="onFileSubmit()" type="button" mat-raised-button
                        class="w-25">
                        <span *ngIf="!isKnowledgeLoading">Upload</span>
                        <mat-icon *ngIf="!isKnowledgeLoading">upload</mat-icon>

                        <mat-spinner *ngIf="isKnowledgeLoading" [diameter]="30" [strokeWidth]="3"
                            class="mx-auto mat-spinner"></mat-spinner>
                    </button>
                </div>
            </div>
        </div>

        <mat-divider class="mt-4 mb-4"></mat-divider>

        <!-- KNOWLEDGE LIST SECTION -->
        <div class="row">
            <h1>Knowledge bases</h1>

            <p *ngIf="aiAgent.knowledgeDocuments.length == 0">You have no
                knowledge base at the moment</p>

            <ng-container>
                <div class="col-6 mb-3" *ngFor="let knowledge of aiAgent.knowledgeDocuments; let i = index">
                    <div class="d-flex flex-column mat-elevation-z2 rounded p-3 h-100">
                        <h1 class="text-center">{{knowledge.name}}</h1>
                        <p><span class="fw-bold">type: </span>{{knowledge.type}}</p>
                        <p><span class="fw-bold">status: </span>{{knowledge.status}}</p>

                        <button [disabled]="isKnowledgeLoading || isDeleteKnowledgeLoading" class="mt-auto w-50 align-self-center"
                            mat-raised-button color="warn" (click)="removeKnowledge(knowledge, i)">
                            <span *ngIf="!isKnowledgeListLoading[i]">Remove</span>

                            <mat-spinner *ngIf="isKnowledgeListLoading[i]" [diameter]="30" [strokeWidth]="3"
                                class="mx-auto mat-spinner"></mat-spinner>
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>

        <mat-divider class="mt-5 mb-5"></mat-divider>

        <!-- SERVICES -->
        <div class="row d-flex" *ngIf="serviceForm" [formGroup]="serviceForm">
            <h1 class="text-center mb-1">Services</h1>
            <h2 class="fw-light text-center">Enter the services that your company offers (optional)</h2>
            <ng-container formArrayName="services">
                <ng-container *ngFor="let service of services.controls; let i = index">
                    <div [formGroup]="service" class="mat-elevation-z2 p-3 rounded">
                        <mat-divider *ngIf="i > 0" class="mt-3 mb-3"></mat-divider>
                        <div class="col-12 d-flex flex-row">
                            <h1>Service {{i + 1}}</h1>
                            <button (click)="onRemoveService(i)" mat-mini-fab class="text-dark bg-white ms-auto">
                                <mat-icon>remove</mat-icon>
                            </button>
                        </div>
                        <div class="col-6">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Name</mat-label>
                                <input matInput placeholder="Ex: Cleaning" required formControlName="name">
                                <mat-hint>The name of the service offered</mat-hint>
                            </mat-form-field>
                        </div>

                        <div class="col-6">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Price</mat-label>
                                <input matInput type="number" placeholder="5.99" required formControlName="price">
                                <mat-hint>The price of the service</mat-hint>
                            </mat-form-field>
                        </div>

                        <div class="col-12 mt-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Description</mat-label>
                                <textarea rows="10" matInput formControlName="description"></textarea>
                                <mat-hint>The description of the service</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>

        <div class="col-12 d-flex justify-content-center mt-4">
            <button type="button" (click)="addService()" mat-fab class="bg-light text-dark me-2"
                aria-label="Example icon button with a delete icon">
                <mat-icon>add</mat-icon>
            </button>
        </div>

        <mat-divider class="mt-5 mb-5"></mat-divider>

        <div class="col-12 text-center">
            <button [disabled]="isServicesLoading || (serviceForm && (!serviceForm.valid || services.length == 0))"
                class="mt-auto w-25 align-self-center" mat-raised-button (click)="onServicesSubmit()">
                <span *ngIf="!isServicesLoading">Save</span>

                <mat-spinner *ngIf="isServicesLoading" [diameter]="30" [strokeWidth]="3"
                    class="mx-auto mat-spinner"></mat-spinner>
            </button>
        </div>
    </div>
</div>